import dayjs from 'dayjs';
import dayOfYear from 'dayjs/plugin/dayOfYear';
import merge from 'lodash.merge';

import { basicInitialState } from '../../_utils/basicInitialState';
import { INITIAL_SETTINGS, START_YEAR } from './catchesConstants';
import { SettingsService } from 'services/settings';

import { TCatchesPeriod } from 'types';
import { TCatchesState } from './catchesModel';

dayjs.extend(dayOfYear);

/**/
const settings =
  SettingsService.readSettings()[SettingsService.HISTORICAL_CATCH_FILTER];

/**
 *
 */
export function getDefaultPeriod(): TCatchesPeriod {
  const start = dayjs(
    `${START_YEAR}-${dayjs().month() + 1}-${dayjs().date()}`
  ).dayOfYear();

  return {
    end: dayjs().add(3, 'month').dayOfYear(),
    start: start,
    years: [START_YEAR, 2024]
  };
}

/**
 *
 */
export const catchesInitialState: TCatchesState = {
  ...basicInitialState,
  cardCount: 0,
  activities: [],
  catchVisualization: [],
  clusters: [],
  isCatchMode: settings?.isCatchMode || false,
  isPanelExpanded: false,
  options: {
    species: [],
    types: [],
    vessels: []
  },
  period: settings?.period || getDefaultPeriod(),
  settings: settings?.options
    ? merge({}, INITIAL_SETTINGS, settings.options)
    : INITIAL_SETTINGS
};
